import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Theme } from '@app/theme';
import { createUseStyles, useTheme } from 'react-jss';
import { CleanCenteredPage } from 'components/PageLayout/CleanCenteredPage';
import { Link } from '@app/core';
import Check from '@app/illu/Large/Check.svg';

const useStyles = createUseStyles((theme: Theme) => ({
  text: {
    ...theme.fonts.body,
    color: theme.colors.inkSecondary,
    marginTop: theme.marginBase * 3,
  },
  link: {
    textAlign: 'center',
    marginTop: theme.marginBase * 4,
  },
}));

export const ChangePasswordSuccess = () => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();
  return (
    <CleanCenteredPage
      title={t('forgottenPassword.changeSuccess.title')}
      illustration={Check}
    >
      <p className={classes.text}>
        <Trans i18nKey="forgottenPassword.changeSuccess.body" />
      </p>

      <p className={classes.link}>
        <Link to="/login">
          <Trans i18nKey="forgottenPassword.changeSuccess.link" />
        </Link>
      </p>
    </CleanCenteredPage>
  );
};
